import React from "react";
import "./tabs.scss";

const Tabs = ({
  tabsTitles,
  activeTab,
  setActiveTab,
  TabIcons = [],
  tabIconKeys,
  marginBottom = "16px",
  showTabIcons = true
}) => {
  return (
    <div className="formTabs" style={{ marginBottom }}>
      <div className="tabsBox">
        {tabsTitles?.map((itm, ind) => (
          <p
            onClick={() => setActiveTab(ind)}
            key={ind}
            className={activeTab === ind ? "active" : ""}
          >
            {showTabIcons && (
              <TabIcons
                type={tabIconKeys[ind]}
                color={
                  activeTab === ind
                    ? "var(--text-highlight)"
                    : "var(--text-grey-weak)"
                }
              />
            )}
            {itm}
            {/* Inline tab indicator */}
            <span className="tabIndicator" />
          </p>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
